// Index constants
export const FIRST_INDEX = 0;
export const SECOND_INDEX = 1;

// Date formatting constants
export const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// Month offset for date calculation
export const MONTH_OFFSET = 2;
